import { MODEL_ID } from 'Pods/ThreeDStudio/Store/constants'

import { parseHyper3dImageTo3dGen2Data } from './Utils/parseHyper3dImageTo3dGen2Data'
import { parseHyper3dRetextureProData } from './Utils/parseHyper3dRetextureProData'
import { parseHyper3dTextTo3dGen2Data } from './Utils/parseHyper3dTextTo3dGen2Data'
import { parseMeshyAnimationProData } from './Utils/parseMeshyAnimationProData'
import { parseMeshyImageTo3dProData } from './Utils/parseMeshyImageTo3dProData'
import { parseMeshyMeshSimplificationProData } from './Utils/parseMeshyMeshSimplificationProData'
import { parseMeshyRetextureProData } from './Utils/parseMeshyRetextureProData'
import { parseMeshyTextTo3dProData } from './Utils/parseMeshyTextTo3dProData'
import { parseTencentImageTo3dProData } from './Utils/parseTencentImageTo3dProData'
import { parseTencentMeshSegmentationProData } from './Utils/parseTencentMeshSegmentationProData'
import { parseTencentMeshSimplificationProData } from './Utils/parseTencentMeshSimplificationProData'
import { parseTencentRetextureProData } from './Utils/parseTencentRetextureProData'
import { parseTencentTextTo3dProData } from './Utils/parseTencentTextTo3dProData'
import { parseTripo3dAnimationDefaultData } from './Utils/parseTripo3dAnimationDefaultData'
import { parseTripo3dImageTo3dDefaultData } from './Utils/parseTripo3dImageTo3dDefaultData'
import { parseTripo3dMeshSegmentationDefaultData } from './Utils/parseTripo3dMeshSegmentationDefaultData'
import { parseTripo3dMeshSimplificationDefaultData } from './Utils/parseTripo3dMeshSimplificationDefaultData'
import { parseTripo3dRetextureDefaultData } from './Utils/parseTripo3dRetextureDefaultData'
import { parseTripo3dTextTo3dDefaultData } from './Utils/parseTripo3dTextTo3dDefaultData'

/**
 * Builds a state patch from an openedModel (library run) for the ThreeDStudio store.
 * Dispatches to the parser matching openedModel.providerModelId so the inverse of
 * buildGeneratePayload is applied per provider/model.
 *
 * Returns `{ openedModel: {} }` when the run is empty (missing id or providerModelId)
 * or when the providerModelId is not recognized; in those cases setOpenedModel
 * resets modelSettings/remeshSettings/textureSettings to their DEFAULT_* values.
 *
 * @param {Object} openedModel - Run object from library; use {} to clear
 * @returns {Object} - State patch to pass to setState (shape varies per parser)
 */
export const openedModelToStatePatch = (openedModel) => {
  const isEmpty = !openedModel || openedModel.id == null || openedModel.providerModelId == null
  if (isEmpty) {
    return { openedModel: {} }
  }

  switch (openedModel.providerModelId) {
    case MODEL_ID.TENCENT_IMAGE_TO_3D_PRO:
      return parseTencentImageTo3dProData(openedModel)
    case MODEL_ID.TENCENT_TEXT_TO_3D_PRO:
      return parseTencentTextTo3dProData(openedModel)
    case MODEL_ID.TENCENT_MESH_SIMPLIFICATION_PRO:
      return parseTencentMeshSimplificationProData(openedModel)
    case MODEL_ID.TENCENT_MESH_SEGMENTATION_PRO:
      return parseTencentMeshSegmentationProData(openedModel)
    case MODEL_ID.TENCENT_RETEXTURE_PRO:
      return parseTencentRetextureProData(openedModel)
    case MODEL_ID.TRIPO3D_IMAGE_TO_3D_DEFAULT:
      return parseTripo3dImageTo3dDefaultData(openedModel)
    case MODEL_ID.TRIPO3D_TEXT_TO_3D_DEFAULT:
      return parseTripo3dTextTo3dDefaultData(openedModel)
    case MODEL_ID.TRIPO3D_RETEXTURE_DEFAULT:
      return parseTripo3dRetextureDefaultData(openedModel)
    case MODEL_ID.MESHY_TEXT_TO_3D_PRO:
      return parseMeshyTextTo3dProData(openedModel)
    case MODEL_ID.MESHY_IMAGE_TO_3D_PRO:
      return parseMeshyImageTo3dProData(openedModel)
    case MODEL_ID.MESHY_RETEXTURE_PRO:
      return parseMeshyRetextureProData(openedModel)
    case MODEL_ID.MESHY_MESH_SIMPLIFICATION_PRO:
      return parseMeshyMeshSimplificationProData(openedModel)
    case MODEL_ID.TRIPO3D_MESH_SIMPLIFICATION_DEFAULT:
      return parseTripo3dMeshSimplificationDefaultData(openedModel)
    case MODEL_ID.TRIPO3D_MESH_SEGMENTATION_DEFAULT:
      return parseTripo3dMeshSegmentationDefaultData(openedModel)
    case MODEL_ID.HYPER3D_TEXT_TO_3D_GEN2:
      return parseHyper3dTextTo3dGen2Data(openedModel)
    case MODEL_ID.HYPER3D_IMAGE_TO_3D_GEN2:
      return parseHyper3dImageTo3dGen2Data(openedModel)
    case MODEL_ID.HYPER3D_RETEXTURE_PRO:
      return parseHyper3dRetextureProData(openedModel)
    case MODEL_ID.MESHY_ANIMATION_PRO:
      return parseMeshyAnimationProData(openedModel)
    case MODEL_ID.TRIPO3D_ANIMATION_DEFAULT:
      return parseTripo3dAnimationDefaultData(openedModel)
    default:
      return { openedModel: {} }
  }
}
